import * as THREE from 'three';
import TWEEN from '@tweenjs/tween.js';
import {USE_LEGACY_TWEEN_GROUP} from 'components/customer/Preview3DCommon/lib/tween';
import {AnimationHandler} from 'components/customer/Preview3D/animation/entity/AnimationHandler';

export const toggleCornerHandler = ({
    mesh,
    isRightDoor = false,
}: {
    mesh: THREE.Group<THREE.Object3DEventMap>;
    isRightDoor: boolean;
}): AnimationHandler => {
    const degrees = 90;
    const radians = (degrees * Math.PI) / 180;

    const initialRotation = {y: (45 * Math.PI) / 180};
    const openRotation = {
        y: isRightDoor ? (170 * Math.PI) / 180 : -radians,
    };
    const closeRotation = {y: (45 * Math.PI) / 180};

    const openDrawer = (animationSpeed = 1000) =>
        new Promise<void>((resolve) => {
            const openTween = new TWEEN.Tween(
                initialRotation,
                USE_LEGACY_TWEEN_GROUP
            )
                .to(openRotation, animationSpeed)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onComplete(() => {
                    resolve();
                })
                .onUpdate(() => {
                    mesh.rotation.y = initialRotation.y;
                });

            openTween.start();
        });

    const closeDrawer = (animationSpeed = 1000) =>
        new Promise<void>((resolve) => {
            const close = new TWEEN.Tween(
                initialRotation,
                USE_LEGACY_TWEEN_GROUP
            )
                .to(closeRotation, animationSpeed)
                .easing(TWEEN.Easing.Quadratic.Out)
                .onComplete(() => {
                    resolve();
                })
                .onUpdate(() => {
                    mesh.rotation.y = initialRotation.y;
                });

            close.start();
        });

    return {
        open: [openDrawer],
        close: [closeDrawer],
    };
};
